
















































































































































































































































































































































































































































































































































































































































import { Component, Vue, Prop } from 'vue-property-decorator'

@Component({
  name: 'i-phone-contact-block'
})
export default class IPhoneContactBlock extends Vue {
  @Prop({type: String, default: 'ru'}) protected lang!: string
}
